import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Tax Inquiry';

export const TIRoutes = [
  {
    path: '/tax/taxinquiry',
    name: 'Tax-Inquiry',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/TaxInquiry.vue'),
    children: [
      {
        path: 'taxrollsearch',
        name: 'Tax - Tax Inquiry - Tax Roll',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/TaxInquiry/TaxrollSearch.vue'),
      },
      {
        path: 'ownersearch',
        name: 'Tax - Tax Inquiry - Owner',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/TaxInquiry/OwnerSearch.vue'),
      },
      {
        path: 'mobile-home',
        name: 'Tax - Tax Inquiry - Mobile Home',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/TaxInquiry/MobileHome.vue'),
      },
      {
        path: 'reports',
        name: 'Tax - Tax Inquiry  - Reports',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/TaxInquiry/Reports.vue'),
      },
    ],
  },
];

TIRoutes.forEach((element, index) => {
  TIRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria([...authRoles.TaxRead, ...authRoles.TaxAuth], next);
  };
});

export default TIRoutes;
